import { render, staticRenderFns } from "./kongGw.vue?vue&type=template&id=49e3f4e4&scoped=true&"
import script from "./kongGw.vue?vue&type=script&lang=js&"
export * from "./kongGw.vue?vue&type=script&lang=js&"
import style0 from "./kongGw.vue?vue&type=style&index=0&id=49e3f4e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e3f4e4",
  null
  
)

export default component.exports